module.exports = __webpack_public_path__ + "static/ccal-2d74989a629811924d54f8f083e83d25.png";